import React from "react";
import useHover from "../hooks/useHover";

const SafetyModal = ({ text, onComplete }) => {
  return (
    <div
      className="divColumn"
      style={{
        backgroundColor: "#2f2f2f",
        padding: "2px",
        border: "2px solid white",
        borderRadius: ".5rem/.5rem",
      }}
    >
      <div className="textBoldWhite">{text}</div>
      <div className="divRow" style={{ width: "100%" }}>
        <YesNoButton text="No" onClick={onComplete} />
        <YesNoButton text="Yes" onClick={onComplete} />
      </div>
    </div>
  );
};

const YesNoButton = ({ text, onClick }) => {
  const hover = useHover();
  return (
    <div
      {...hover.divProps}
      className="textBoldWhite"
      onClick={() => onClick(text)}
      style={{
        cursor: "pointer",
        opacity: hover.hover ? 1 : 0.7,
        flex: 1,
        padding: "5px",
        backgroundColor: text == "Yes" ? "green" : "red",
        height: "20px",
        border: "1px solid grey",
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        textAlign: "center",
      }}
    >
      {text}
    </div>
  );
};

export default SafetyModal;
